<template>
  <div class="homeFree">
    <div style="margin-bottom: 15px;">
      <el-select v-model="searchBar.state" clearable placeholder="请选择状态" filterable @change="getSearchDate(true)">
        <el-option label="启用" value="1"></el-option>
        <el-option label="不启用" value="0"></el-option>
      </el-select>
      <el-input placeholder="请输入asin" v-model="searchBar.asin" style="width:180px;" clearable></el-input>
      <el-input placeholder="请输入内部SKU" v-model="searchBar.psku" style="width:150px;" clearable></el-input>
      <el-input placeholder="请输入礼品SKU" v-model="searchBar.giftSku" style="width:220px;" clearable>
        <el-button slot="append" icon="el-icon-search" @click="getSearchDate(true)"></el-button>
      </el-input>
    </div>
    <el-table :data="tableData" style="width: 100%" ref="out-table">
      <el-table-column label="ID" prop="id" width="100"></el-table-column>
      <el-table-column label="图片路径" prop="imgUrl" width="120" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.imgUrl" style="height:80px;">
        </template>
      </el-table-column>
      <el-table-column label="描述" prop="description" width="300" show-overflow-tooltip></el-table-column>
      <el-table-column label="启用状态" prop="state">
        <template slot-scope="scope">
          <div v-if="scope.row.state == 0">不启用</div>
          <div v-else>启用</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="更新时间" prop="update_date"></el-table-column>
      <el-table-column label="创建时间" prop="create_date"></el-table-column> -->
      <el-table-column label="ASIN" prop="asin"></el-table-column>
      <el-table-column label="礼品SKU" prop="giftSku"></el-table-column>
      <el-table-column label="销售渠道" prop="salesChannel"></el-table-column>
      <el-table-column label="操作">
        <template slot="header">
          <el-button type="primary" size="mini" @click="AddDialogVisible = true">新增</el-button>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="editGiftDate(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="size"
        :page-sizes="[5, 10, 20,30,50,60,70,100]"
        layout="sizes,prev, pager, next, jumper"
        :total="total">
    </el-pagination>
    <!-- 新增对话框 -->
    <el-dialog title="新增" :visible.sync="AddDialogVisible" width="30%" center>
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto" class="demo-ruleForm">
        <el-form-item label="Product Url:" prop="imgUrl" ref="imgUrl">
          <el-input v-model="addForm.imgUrl" v-if="false"></el-input>
          <el-upload
              action="#"
              list-type="picture-card"
              :http-request="uploadFile"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="addForm.imgUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="addForm.description"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="state" style="width:100%;">
          <el-select v-model="addForm.state" placeholder="请选择状态">
            <el-option label="不启用" value="0"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="更新时间" prop="update_date">
          <el-date-picker v-model="addForm.update_date" type="datetime"  placeholder="选择更新时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_date">
          <el-date-picker v-model="addForm.create_date" type="datetime"  placeholder="选择创建时间"></el-date-picker>
        </el-form-item> -->
        <el-form-item label="ASIN" prop="asin">
          <el-input v-model="addForm.asin"></el-input>
        </el-form-item>
        <el-form-item label="礼品SKU" prop="giftSku">
          <el-input v-model="addForm.giftSku"></el-input>
        </el-form-item>
        <el-form-item label="销售渠道" prop="salesChannel">
          <el-input v-model="addForm.salesChannel"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('addForm')">立即创建</el-button>
            <el-button @click="resetForm('addForm')">取消</el-button>
        </span>
    </el-dialog>
    <!-- 编辑对话框 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="30%" center>
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="auto" class="demo-ruleForm">
        <el-form-item label="Product Url:" prop="imgUrl" ref="imgUrl">
          <el-upload
              action="#"
              list-type="picture-card"
              :http-request="editUploadFile"
              :limit="1"
              :file-list="fileDate"
              :on-exceed="editHandleExceed"
              :on-remove="editHandleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="editForm.imgUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="editForm.description"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="state" style="width:100%;">
          <el-select v-model="editForm.state" placeholder="请选择状态">
            <el-option label="不启用" value="0"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="更新时间" prop="update_date">
          <el-date-picker v-model="editForm.update_date" type="datetime"  placeholder="选择更新时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_date">
          <el-date-picker v-model="editForm.create_date" type="datetime"  placeholder="选择创建时间"></el-date-picker>
        </el-form-item> -->
        <el-form-item label="ASIN" prop="asin">
          <el-input v-model="editForm.asin"></el-input>
        </el-form-item>
        <el-form-item label="礼品SKU" prop="giftSku">
          <el-input v-model="editForm.giftSku"></el-input>
        </el-form-item>
        <el-form-item label="销售渠道" prop="salesChannel">
          <el-input v-model="editForm.salesChannel"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitFormEdit('editForm')">确定</el-button>
            <el-button @click="resetFormEdit('editForm')">取消</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
// 
import {giftList, giftUploadPictures, giftDeletePictures, addGift, editGift} from '../../api/homeFreeGift'

export default {
  data() {
    return {
      tableData: [],
      page: 1,
      size: 10,
      total: 10,
      searchBar: {
        state: '',
        asin: '',
        psku: '',
        giftSku: ''
      },
      AddDialogVisible: false,
      dialogVisible: false,
      addForm: {
        imgUrl: ''
      },
      editDialogVisible: false,
      editForm: {imgUrl: ''},
      labelPosition: "right",
      rules: {
        description: [
          {required: true, message: '请填写活动形式', trigger: 'blur'}
        ],
        state: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        update_date: [
          {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        create_date: [
          {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        asin: [
          {required: true, message: '请输入asin', trigger: 'blur'}
        ],
        giftSku: [
          {required: true, message: '请输入礼品SKU', trigger: 'blur'}
        ],
        salesChannel: [
          {required: true, message: '请输入销售渠道', trigger: 'blur'}
        ]
      },
      fileList: [{imgUrl: []}],
      fileDate: [{url: []}],
    }
  },
  methods: {
    // 分页选择条数触发
    handleSizeChange(size) {
      this.size = size;
      this.getSearchDate();
    },
    // 分页选择页面触发
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSearchDate();
    },
    //  多条件搜索
    getSearchDate(boolean) {

      this.searchBar = this.common.clearNull(this.searchBar);
      this.page = boolean ? 1 : this.page;
      giftList({page: this.page, size: this.size, q: JSON.stringify(this.searchBar)}).then((res => {
        if (res.data.code === 200) {
          if (boolean) {
            this.$message.success(res.data.message);
          }
          this.tableData = res.data.data.content;
          this.total = res.data.data.total_elements;
        }
      }))
    },
    // 查询
    // search(){
    //     for (const key in this.searchBar) {
    //         if(this.searchBar[key] == '' || this.searchBar[key] == undefined){
    //             delete this.searchBar[key]
    //         }
    //     }
    //     giftList({page:this.page =1,size:this.size,q:this.searchBar}).then((res=>{
    //         if (res.data.code === 200){
    //             this.$message.success(res.data.message);
    //             this.tableData = res.data.data.content;
    //             this.total = res.data.data.total_elements;
    //         }
    //     }))
    // },
    // 文件上传
    uploadFile(params) {
      const _file = params.file;
      const isLt2M = _file.size / 1024 / 1024 < 2;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      if (!isLt2M) {
        this.$message.error("请上传2M以下的图片");
        return false;
      }
      // console.log(formData);
      giftUploadPictures(formData).then((res => {
        if (res.data.code == 200) {
          this.$message.success('上传成功');
          this.addForm.imgUrl = res.data.message;
        }
      }))
    },
    // 文件超出上传限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 张，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    // 上传前的格式大小限制
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const extension = testmsg === 'JPG' || testmsg === 'jpg' || testmsg === 'png' || testmsg === 'PNG' || testmsg === 'gif' || testmsg === 'jpeg';
      /* eslint-disable */
      const isLt50M = file.size / 1024 / 1024 < 3;
      if (!extension) {
        this.$message({
          message: '图片格式只能是png、jpg、jpeg、gif',
          type: 'error'
        })
        return false;
      }
      if (!isLt50M) {
        this.$message({
          message: '图片大小不能超过3MB!',
          type: 'error'
        })
        return false;
      }
      return extension || isLt50M;
    },
    // 删除图片
    handleRemove() {
      const imgUrl = [];
      imgUrl.push(this.addForm.imgUrl)
      giftDeletePictures({imgUrl: imgUrl}).then((res => {
        if (res.data.code == 200) {
          this.addForm.imgUrl = '';
          this.$message.success(res.data.message);
        } else {
          this.$message(res.data.message)
        }
      }))
    },
    // 确定提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.imgUrl == '' || this.addForm.imgUrl == undefined || this.addForm.imgUrl == null) {
            this.$message('图片不能为空')
            return false;
          } else {
            addGift(this.addForm).then((res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.AddDialogVisible = false;
                this.getSearchDate(false);
                this.$refs[formName].resetFields();
              } else {
                this.$message(res.data.message)
              }
            }))
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹框
    resetForm(formName) {
      this.AddDialogVisible = false;
      this.$refs[formName].resetFields();
    },
    // 列表
    // getGiftList(){
    //     giftList({page:this.page,size:this.size}).then((res=>{
    //         if (res.data.code === 200){
    //             this.tableData = res.data.data.content;
    //             this.total = res.data.data.total_elements;
    //         }
    //     }))
    // },
    // 编辑
    editGiftDate(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
      this.fileDate[0].url.push(this.editForm.imgUrl);
    },
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editGift({
            id: this.editForm.id,
            data: this.editForm
          }).then((res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.$refs[formName].resetFields();
              //  成功之后再删除图片
              if (this.fileList[0].imgUrl.length != 0) {
                giftDeletePictures({imgUrl: this.fileList[0].imgUrl});
              }
              this.editDialogVisible = false;
              this.getSearchDate(false);
            } else {
              this.$message(res.data.message)
            }
          }))
        } else {
          return false;
        }
      });
    },
    // 关闭弹框
    resetFormEdit(formName) {
      this.editDialogVisible = false;
      this.$refs[formName].resetFields();
    },
    // 编辑上传图片
    editUploadFile(params) {
      const _file = params.file;
      const isLt2M = _file.size / 1024 / 1024 < 2;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      if (!isLt2M) {
        this.$message.error("请上传2M以下的图片");
        return false;
      }
      giftUploadPictures(formData).then((res => {
        if (res.data.code == 200) {
          this.$message.success('上传成功');
          this.editForm.imgUrl = res.data.message;
        }
      }))
    },
    // 编辑限制上传个数
    editHandleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 张，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    // 编辑中的删除图片
    editHandleRemove() {
      this.fileList[0].imgUrl.push(this.editForm.imgUrl);
      this.editForm.imgUrl = '';
    }
  },
  created() {
    this.getSearchDate(true);
  }
}
</script>
<style lang="less" scoped>
.homeFree {
  padding: 50px 30px;

  .el-select .el-input {
    width: 150px;
  }
}

.el-input-group {
  // margin-left: 30px;
  width: 500px;
}

// .el-table {
//   padding: 50px 30px;
// }
.el-pagination {
  padding: 32px 0px;
}

.el-select > .el-input {
  width: 80% !important;
}

</style>